import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CloudDownload = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16, ...props }, forwardedRef) => {
    return (
      <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill={'none'}
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M10 10.5H12C13.7677 10.5 15 9.35516 15 7.92849C15 6.77446 14.1862 5.65373 12.9843 5.39219C12.9433 4.4467 12.477 3.74064 11.8332 3.36823C11.202 3.00298 10.4223 2.95861 9.73433 3.23763C9.1827 2.27844 8.09549 1.5 6.66647 1.5C4.54081 1.5 3.04265 3.29023 3.15099 5.11611C1.91738 5.41251 1 6.48885 1 7.76786C1 9.27491 2.27048 10.5 3.83331 10.5H6"
          stroke={color}
          strokeLinecap="round"
        />
        <path
          d="M8 15L8 8.5M8 15L10.5 12.5M8 15L5.5 12.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default CloudDownload
